
import { Component, Prop, Vue } from 'vue-property-decorator';

import { mixins } from 'vue-class-component';
import EndpointData from './data-mixin';

@Component({
    components: {
    }
})
export default class QueryEndpointData extends mixins(EndpointData) {

    // Supply chain leg config prop.
    @Prop() protected config!: any;

    // Display props.
    @Prop() protected commodity!: string;
    @Prop() protected metric!: any;
    @Prop() protected spatial_type!: any;
    @Prop() protected border_crossings!: number | null;
    @Prop() protected spatial_selection!: string;
    @Prop() protected supply_chain_leg!: string;
    @Prop() protected metric_type?: any;
    @Prop() protected border_crossings_chart_metric?: string | null;
    @Prop() spatialBorderCrossing!: boolean;


    get regions() {
        // Prepend the direction into the region selected.
        return this.config.direction + '_' + this.spatial_type.value;
    }

    get updateRequired() {
        // A getter for inheritortors to watch if the data requires updating.
        return `${this.commodity} | ${this.border_crossings} | ${this.spatial_selection} | ${this.supply_chain_leg} | ${this.metric.value} | ${this.spatial_type.value}`;
    }

    supply_chain_leg_direction(supply_chain_leg: string) {
        return supply_chain_leg !== 'consumption_exports' ? 'orig' : 'dest';
    }

    define_metric(map_id: string, metric: string): string {
        if (this.border_crossings_chart_metric) {
            return this.border_crossings_chart_metric;
        }

        if (metric !== "tonnes") {
            if (["production_imports", "processing", "distribution"].includes(map_id)) {
                return "to_" + metric;
            } else if (map_id === "consumption_exports") {
                return "from_" + metric;
            }
        }
        return metric;
    }

    getQueryParams() {
        // Build the endpoint url based upon SCE filter values.
        var queryParams: any = {};

        queryParams["dataset"] = this.dataset;
        queryParams["commodity"] = this.commodity;

        if (this.metric_type) {
            queryParams["metric_type"] = this.metric_type;
        }

        queryParams["metric"] = this.define_metric(this.config.map_id, this.metric.value);

        if (this.border_crossings != null) {
            queryParams["border_crossings"] = this.border_crossings;
        }
        queryParams["regions"] = this.regions;
        queryParams["map_id"] = this.config.map_id;

        if (this.spatial_selection) {
            //queryParams[this.config.direction + "_region"] = this.spatial_selection;
            //queryParams[this.config.direction + "_region_category"] = this.regions;

            // Orig/dest regions should be based on a supply chain leg selected
            queryParams[this.supply_chain_leg_direction(this.supply_chain_leg) + "_region"] = this.spatial_selection;
            //queryParams[this.supply_chain_leg_direction(this.supply_chain_leg) + "_region_category"] = this.regions; //Not needed, same as regions
            queryParams["supply_chain_leg"] = this.supply_chain_leg;
        }

        if (this.spatialBorderCrossing && !this.spatial_selection) {
            queryParams["supply_chain_leg"] = this.supply_chain_leg;
        }

        return queryParams;
    }

    numberWithCommas(x: any): string {
        return Number(x).toLocaleString()
    }
}
